// Lightweight i18n dictionary for PrintVault (5 languages).
export const LANGUAGES = [
  { code: "en", label: "English" },
  { code: "de", label: "Deutsch" },
  { code: "es", label: "Español" },
  { code: "fr", label: "Français" },
  { code: "zh", label: "中文" },
  { code: "hi", label: "हिन्दी" },
  { code: "ar", label: "العربية" },
  { code: "pt", label: "Português" },
  { code: "ru", label: "Русский" },
  { code: "ja", label: "日本語" },
  { code: "it", label: "Italiano" },
  { code: "ko", label: "한국어" },
  { code: "nl", label: "Nederlands" },
  { code: "tr", label: "Türkçe" },
  { code: "pl", label: "Polski" },
];

export const RTL_LANGS = ["ar"];

export const translations = {
  en: {
    brand: "andywarhol.ai",
    tagline: "The Printed Advertising Marketplace",
    hero_title: "The Online Market for Printed Advertising Pieces",
    hero_sub: "Buy and sell original vintage printed advertisements — cameras, phones, electronics and more. Every piece a genuine fragment of design history.",
    browse: "Browse the Collection",
    search_placeholder: "Search brand, topic or keyword…",
    filters: "Filters",
    topic: "Topic",
    brands: "Brands",
    era: "Era",
    ad_language: "Ad Language",
    all: "All",
    sort: "Sort",
    sort_random: "Surprise me",
    sort_newest: "Newest",
    sort_price_asc: "Price: low to high",
    sort_price_desc: "Price: high to low",
    results: "pieces",
    load_more: "Load more",
    end_of_catalog: "You've reached the end",
    clear: "Clear all",
    no_results: "No advertisements match your filters.",
    inquire: "Inquire",
    view_details: "View details",
    details: "Details",
    condition: "Condition",
    dimensions: "Dimensions",
    brand_label: "Brand",
    back: "Back to collection",
    hover_zoom: "Hover to zoom",
    click_enlarge: "Click to enlarge",
    on: "On",
    off: "Off",
    inquire_title: "Inquire about this piece",
    inquire_sub: "Send us a message and we'll get back to you about your purchase.",
    your_name: "Your name",
    your_email: "Your email",
    your_message: "Your message",
    send: "Send inquiry",
    sending: "Sending…",
    inquiry_sent: "Your inquiry has been sent. Thank you!",
    inquiry_error: "Something went wrong. Please try again.",
    currency: "Currency",
    language: "Language",
    admin: "Admin",
    // admin
    admin_login: "Admin Login",
    email: "Email",
    password: "Password",
    login: "Log in",
    logout: "Log out",
    dashboard: "Dashboard",
    manage_ads: "Advertisements",
    messages: "Messages",
    add_ad: "Add advertisement",
    edit: "Edit",
    delete: "Delete",
    save: "Save",
    cancel: "Cancel",
    title_field: "Title",
    price_field: "Price (USD)",
    image_url: "Image URL",
    description: "Description",
    reply: "Reply",
    send_reply: "Send reply",
    mark_read: "Mark read",
    unread: "Unread",
    from: "From",
    regarding: "Regarding",
    no_messages: "No messages yet.",
    saved: "Saved",
    deleted: "Deleted",
    reply_sent: "Reply saved",
    confirm_delete: "Delete this item?",
  },
  de: {
    brand: "andywarhol.ai",
    tagline: "Der Marktplatz für gedruckte Werbung",
    hero_title: "Der Online-Markt für gedruckte Werbeanzeigen",
    hero_sub: "Kaufen und verkaufen Sie originale historische Druckwerbung — Kameras, Telefone, Elektronik und mehr. Jedes Stück ein echtes Fragment der Designgeschichte.",
    browse: "Sammlung durchsuchen",
    search_placeholder: "Marke, Thema oder Stichwort suchen…",
    filters: "Filter",
    topic: "Thema",
    era: "Epoche",
    ad_language: "Anzeigensprache",
    all: "Alle",
    sort: "Sortieren",
    sort_random: "Überrasch mich",
    sort_newest: "Neueste",
    sort_price_asc: "Preis: aufsteigend",
    sort_price_desc: "Preis: absteigend",
    results: "Stücke",
    clear: "Zurücksetzen",
    no_results: "Keine Anzeigen entsprechen Ihren Filtern.",
    inquire: "Anfragen",
    view_details: "Details ansehen",
    details: "Details",
    condition: "Zustand",
    dimensions: "Abmessungen",
    brand_label: "Marke",
    back: "Zurück zur Sammlung",
    hover_zoom: "Zum Zoomen bewegen",
    inquire_title: "Zu diesem Stück anfragen",
    inquire_sub: "Senden Sie uns eine Nachricht und wir melden uns zum Kauf.",
    your_name: "Ihr Name",
    your_email: "Ihre E-Mail",
    your_message: "Ihre Nachricht",
    send: "Anfrage senden",
    sending: "Senden…",
    inquiry_sent: "Ihre Anfrage wurde gesendet. Vielen Dank!",
    inquiry_error: "Etwas ist schiefgelaufen. Bitte erneut versuchen.",
    currency: "Währung",
    language: "Sprache",
    admin: "Admin",
    admin_login: "Admin-Anmeldung",
    email: "E-Mail",
    password: "Passwort",
    login: "Anmelden",
    logout: "Abmelden",
    dashboard: "Dashboard",
    manage_ads: "Anzeigen",
    messages: "Nachrichten",
    add_ad: "Anzeige hinzufügen",
    edit: "Bearbeiten",
    delete: "Löschen",
    save: "Speichern",
    cancel: "Abbrechen",
    title_field: "Titel",
    price_field: "Preis (USD)",
    image_url: "Bild-URL",
    description: "Beschreibung",
    reply: "Antworten",
    send_reply: "Antwort senden",
    mark_read: "Als gelesen markieren",
    unread: "Ungelesen",
    from: "Von",
    regarding: "Betreff",
    no_messages: "Noch keine Nachrichten.",
    saved: "Gespeichert",
    deleted: "Gelöscht",
    reply_sent: "Antwort gespeichert",
    confirm_delete: "Dieses Element löschen?",
  },
  es: {
    brand: "andywarhol.ai",
    tagline: "El mercado de la publicidad impresa",
    hero_title: "El mercado online de piezas de publicidad impresa",
    hero_sub: "Compra y vende anuncios impresos originales — cámaras, teléfonos, electrónica y más. Cada pieza, un auténtico fragmento de la historia del diseño.",
    browse: "Explorar la colección",
    search_placeholder: "Buscar marca, tema o palabra clave…",
    filters: "Filtros",
    topic: "Tema",
    era: "Época",
    ad_language: "Idioma del anuncio",
    all: "Todos",
    sort: "Ordenar",
    sort_random: "Sorpréndeme",
    sort_newest: "Más recientes",
    sort_price_asc: "Precio: menor a mayor",
    sort_price_desc: "Precio: mayor a menor",
    results: "piezas",
    clear: "Limpiar todo",
    no_results: "Ningún anuncio coincide con tus filtros.",
    inquire: "Consultar",
    view_details: "Ver detalles",
    details: "Detalles",
    condition: "Estado",
    dimensions: "Dimensiones",
    brand_label: "Marca",
    back: "Volver a la colección",
    hover_zoom: "Pasa el cursor para ampliar",
    inquire_title: "Consultar sobre esta pieza",
    inquire_sub: "Envíanos un mensaje y te responderemos sobre tu compra.",
    your_name: "Tu nombre",
    your_email: "Tu correo",
    your_message: "Tu mensaje",
    send: "Enviar consulta",
    sending: "Enviando…",
    inquiry_sent: "Tu consulta ha sido enviada. ¡Gracias!",
    inquiry_error: "Algo salió mal. Inténtalo de nuevo.",
    currency: "Moneda",
    language: "Idioma",
    admin: "Admin",
    admin_login: "Acceso de administrador",
    email: "Correo",
    password: "Contraseña",
    login: "Iniciar sesión",
    logout: "Cerrar sesión",
    dashboard: "Panel",
    manage_ads: "Anuncios",
    messages: "Mensajes",
    add_ad: "Añadir anuncio",
    edit: "Editar",
    delete: "Eliminar",
    save: "Guardar",
    cancel: "Cancelar",
    title_field: "Título",
    price_field: "Precio (USD)",
    image_url: "URL de imagen",
    description: "Descripción",
    reply: "Responder",
    send_reply: "Enviar respuesta",
    mark_read: "Marcar leído",
    unread: "No leído",
    from: "De",
    regarding: "Sobre",
    no_messages: "Aún no hay mensajes.",
    saved: "Guardado",
    deleted: "Eliminado",
    reply_sent: "Respuesta guardada",
    confirm_delete: "¿Eliminar este elemento?",
  },
  fr: {
    brand: "andywarhol.ai",
    tagline: "La place de marché de la publicité imprimée",
    hero_title: "Le marché en ligne des pièces de publicité imprimée",
    hero_sub: "Achetez et vendez des publicités imprimées originales — appareils photo, téléphones, électronique et plus. Chaque pièce, un authentique fragment d'histoire du design.",
    browse: "Parcourir la collection",
    search_placeholder: "Rechercher marque, thème ou mot-clé…",
    filters: "Filtres",
    topic: "Thème",
    era: "Époque",
    ad_language: "Langue de l'annonce",
    all: "Tous",
    sort: "Trier",
    sort_random: "Surprenez-moi",
    sort_newest: "Plus récents",
    sort_price_asc: "Prix : croissant",
    sort_price_desc: "Prix : décroissant",
    results: "pièces",
    clear: "Tout effacer",
    no_results: "Aucune annonce ne correspond à vos filtres.",
    inquire: "Se renseigner",
    view_details: "Voir les détails",
    details: "Détails",
    condition: "État",
    dimensions: "Dimensions",
    brand_label: "Marque",
    back: "Retour à la collection",
    hover_zoom: "Survolez pour zoomer",
    inquire_title: "Se renseigner sur cette pièce",
    inquire_sub: "Envoyez-nous un message et nous reviendrons vers vous pour l'achat.",
    your_name: "Votre nom",
    your_email: "Votre e-mail",
    your_message: "Votre message",
    send: "Envoyer la demande",
    sending: "Envoi…",
    inquiry_sent: "Votre demande a été envoyée. Merci !",
    inquiry_error: "Une erreur s'est produite. Veuillez réessayer.",
    currency: "Devise",
    language: "Langue",
    admin: "Admin",
    admin_login: "Connexion administrateur",
    email: "E-mail",
    password: "Mot de passe",
    login: "Se connecter",
    logout: "Se déconnecter",
    dashboard: "Tableau de bord",
    manage_ads: "Annonces",
    messages: "Messages",
    add_ad: "Ajouter une annonce",
    edit: "Modifier",
    delete: "Supprimer",
    save: "Enregistrer",
    cancel: "Annuler",
    title_field: "Titre",
    price_field: "Prix (USD)",
    image_url: "URL de l'image",
    description: "Description",
    reply: "Répondre",
    send_reply: "Envoyer la réponse",
    mark_read: "Marquer comme lu",
    unread: "Non lu",
    from: "De",
    regarding: "Concernant",
    no_messages: "Aucun message pour l'instant.",
    saved: "Enregistré",
    deleted: "Supprimé",
    reply_sent: "Réponse enregistrée",
    confirm_delete: "Supprimer cet élément ?",
  },
  zh: {
    brand: "andywarhol.ai",
    tagline: "印刷广告交易市场",
    hero_title: "印刷广告藏品在线市场",
    hero_sub: "买卖原版复古印刷广告 — 相机、手机、电子产品等。每一件都是设计史的真实片段。",
    browse: "浏览藏品",
    search_placeholder: "搜索品牌、主题或关键词…",
    filters: "筛选",
    topic: "主题",
    era: "年代",
    ad_language: "广告语言",
    all: "全部",
    sort: "排序",
    sort_random: "随机推荐",
    sort_newest: "最新",
    sort_price_asc: "价格：从低到高",
    sort_price_desc: "价格：从高到低",
    results: "件",
    clear: "清除全部",
    no_results: "没有符合筛选条件的广告。",
    inquire: "咨询",
    view_details: "查看详情",
    details: "详情",
    condition: "品相",
    dimensions: "尺寸",
    brand_label: "品牌",
    back: "返回藏品",
    hover_zoom: "悬停放大",
    inquire_title: "咨询此藏品",
    inquire_sub: "给我们留言，我们会就购买事宜与您联系。",
    your_name: "您的姓名",
    your_email: "您的邮箱",
    your_message: "您的留言",
    send: "发送咨询",
    sending: "发送中…",
    inquiry_sent: "您的咨询已发送，谢谢！",
    inquiry_error: "出错了，请重试。",
    currency: "货币",
    language: "语言",
    admin: "管理员",
    admin_login: "管理员登录",
    email: "邮箱",
    password: "密码",
    login: "登录",
    logout: "退出",
    dashboard: "控制台",
    manage_ads: "广告",
    messages: "留言",
    add_ad: "添加广告",
    edit: "编辑",
    delete: "删除",
    save: "保存",
    cancel: "取消",
    title_field: "标题",
    price_field: "价格 (USD)",
    image_url: "图片链接",
    description: "描述",
    reply: "回复",
    send_reply: "发送回复",
    mark_read: "标为已读",
    unread: "未读",
    from: "来自",
    regarding: "关于",
    no_messages: "暂无留言。",
    saved: "已保存",
    deleted: "已删除",
    reply_sent: "回复已保存",
    confirm_delete: "删除此项？",
  },
  hi: {
    brand: "andywarhol.ai",
    tagline: "मुद्रित विज्ञापन का बाज़ार",
    hero_title: "मुद्रित विज्ञापन कृतियों का ऑनलाइन बाज़ार",
    hero_sub: "मूल विंटेज मुद्रित विज्ञापन खरीदें और बेचें — कैमरे, फ़ोन, इलेक्ट्रॉनिक्स और बहुत कुछ। हर टुकड़ा डिज़ाइन इतिहास का सच्चा अंश।",
    browse: "संग्रह देखें",
    search_placeholder: "ब्रांड, विषय या कीवर्ड खोजें…",
    filters: "फ़िल्टर",
    topic: "विषय",
    era: "युग",
    ad_language: "विज्ञापन भाषा",
    all: "सभी",
    sort: "क्रमबद्ध करें",
    sort_random: "मुझे आश्चर्यचकित करें",
    sort_newest: "नवीनतम",
    sort_price_asc: "मूल्य: कम से अधिक",
    sort_price_desc: "मूल्य: अधिक से कम",
    results: "टुकड़े",
    clear: "सब हटाएँ",
    no_results: "आपके फ़िल्टर से कोई विज्ञापन मेल नहीं खाता।",
    inquire: "पूछताछ करें",
    view_details: "विवरण देखें",
    details: "विवरण",
    condition: "स्थिति",
    dimensions: "आयाम",
    brand_label: "ब्रांड",
    back: "संग्रह पर वापस जाएँ",
    hover_zoom: "बड़ा करने के लिए होवर करें",
    inquire_title: "इस टुकड़े के बारे में पूछताछ करें",
    inquire_sub: "हमें संदेश भेजें और हम आपकी खरीद के बारे में संपर्क करेंगे।",
    your_name: "आपका नाम",
    your_email: "आपका ईमेल",
    your_message: "आपका संदेश",
    send: "पूछताछ भेजें",
    sending: "भेजा जा रहा है…",
    inquiry_sent: "आपकी पूछताछ भेज दी गई है। धन्यवाद!",
    inquiry_error: "कुछ गलत हो गया। कृपया पुनः प्रयास करें।",
    currency: "मुद्रा",
    language: "भाषा",
    admin: "एडमिन",
    admin_login: "एडमिन लॉगिन",
    email: "ईमेल",
    password: "पासवर्ड",
    login: "लॉग इन",
    logout: "लॉग आउट",
    dashboard: "डैशबोर्ड",
    manage_ads: "विज्ञापन",
    messages: "संदेश",
    add_ad: "विज्ञापन जोड़ें",
    edit: "संपादित करें",
    delete: "हटाएँ",
    save: "सहेजें",
    cancel: "रद्द करें",
    title_field: "शीर्षक",
    price_field: "मूल्य (USD)",
    image_url: "छवि URL",
    description: "विवरण",
    reply: "उत्तर दें",
    send_reply: "उत्तर भेजें",
    mark_read: "पढ़ा हुआ चिह्नित करें",
    unread: "अपठित",
    from: "प्रेषक",
    regarding: "विषय",
    no_messages: "अभी तक कोई संदेश नहीं।",
    saved: "सहेजा गया",
    deleted: "हटाया गया",
    reply_sent: "उत्तर सहेजा गया",
    confirm_delete: "इस आइटम को हटाएँ?",
  },
  ar: {
    brand: "andywarhol.ai",
    tagline: "سوق الإعلانات المطبوعة",
    hero_title: "السوق الإلكتروني لقطع الإعلانات المطبوعة",
    hero_sub: "اشترِ وبع إعلانات مطبوعة أصلية — كاميرات وهواتف وإلكترونيات والمزيد. كل قطعة شذرة أصيلة من تاريخ التصميم.",
    browse: "تصفح المجموعة",
    search_placeholder: "ابحث عن علامة تجارية أو موضوع أو كلمة…",
    filters: "المرشحات",
    topic: "الموضوع",
    era: "الحقبة",
    ad_language: "لغة الإعلان",
    all: "الكل",
    sort: "ترتيب",
    sort_random: "فاجئني",
    sort_newest: "الأحدث",
    sort_price_asc: "السعر: من الأقل إلى الأعلى",
    sort_price_desc: "السعر: من الأعلى إلى الأقل",
    results: "قطعة",
    clear: "مسح الكل",
    no_results: "لا توجد إعلانات تطابق مرشحاتك.",
    inquire: "استفسار",
    view_details: "عرض التفاصيل",
    details: "التفاصيل",
    condition: "الحالة",
    dimensions: "الأبعاد",
    brand_label: "العلامة التجارية",
    back: "العودة إلى المجموعة",
    hover_zoom: "مرّر للتكبير",
    inquire_title: "استفسر عن هذه القطعة",
    inquire_sub: "أرسل لنا رسالة وسنعاود التواصل بشأن الشراء.",
    your_name: "اسمك",
    your_email: "بريدك الإلكتروني",
    your_message: "رسالتك",
    send: "إرسال الاستفسار",
    sending: "جارٍ الإرسال…",
    inquiry_sent: "تم إرسال استفسارك. شكرًا لك!",
    inquiry_error: "حدث خطأ ما. يرجى المحاولة مرة أخرى.",
    currency: "العملة",
    language: "اللغة",
    admin: "المشرف",
    admin_login: "دخول المشرف",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    login: "تسجيل الدخول",
    logout: "تسجيل الخروج",
    dashboard: "لوحة التحكم",
    manage_ads: "الإعلانات",
    messages: "الرسائل",
    add_ad: "إضافة إعلان",
    edit: "تعديل",
    delete: "حذف",
    save: "حفظ",
    cancel: "إلغاء",
    title_field: "العنوان",
    price_field: "السعر (USD)",
    image_url: "رابط الصورة",
    description: "الوصف",
    reply: "رد",
    send_reply: "إرسال الرد",
    mark_read: "وضع علامة مقروء",
    unread: "غير مقروء",
    from: "من",
    regarding: "بخصوص",
    no_messages: "لا توجد رسائل بعد.",
    saved: "تم الحفظ",
    deleted: "تم الحذف",
    reply_sent: "تم حفظ الرد",
    confirm_delete: "حذف هذا العنصر؟",
  },
  pt: {
    brand: "andywarhol.ai",
    tagline: "O mercado da publicidade impressa",
    hero_title: "O mercado online de peças de publicidade impressa",
    hero_sub: "Compre e venda anúncios impressos originais — câmeras, telefones, eletrônicos e mais. Cada peça, um autêntico fragmento da história do design.",
    browse: "Explorar a coleção",
    search_placeholder: "Pesquisar marca, tema ou palavra-chave…",
    filters: "Filtros",
    topic: "Tema",
    era: "Época",
    ad_language: "Idioma do anúncio",
    all: "Todos",
    sort: "Ordenar",
    sort_random: "Surpreenda-me",
    sort_newest: "Mais recentes",
    sort_price_asc: "Preço: menor para maior",
    sort_price_desc: "Preço: maior para menor",
    results: "peças",
    clear: "Limpar tudo",
    no_results: "Nenhum anúncio corresponde aos seus filtros.",
    inquire: "Consultar",
    view_details: "Ver detalhes",
    details: "Detalhes",
    condition: "Condição",
    dimensions: "Dimensões",
    brand_label: "Marca",
    back: "Voltar à coleção",
    hover_zoom: "Passe o mouse para ampliar",
    inquire_title: "Consultar sobre esta peça",
    inquire_sub: "Envie-nos uma mensagem e retornaremos sobre a sua compra.",
    your_name: "Seu nome",
    your_email: "Seu e-mail",
    your_message: "Sua mensagem",
    send: "Enviar consulta",
    sending: "Enviando…",
    inquiry_sent: "Sua consulta foi enviada. Obrigado!",
    inquiry_error: "Algo deu errado. Tente novamente.",
    currency: "Moeda",
    language: "Idioma",
    admin: "Admin",
    admin_login: "Acesso do administrador",
    email: "E-mail",
    password: "Senha",
    login: "Entrar",
    logout: "Sair",
    dashboard: "Painel",
    manage_ads: "Anúncios",
    messages: "Mensagens",
    add_ad: "Adicionar anúncio",
    edit: "Editar",
    delete: "Excluir",
    save: "Salvar",
    cancel: "Cancelar",
    title_field: "Título",
    price_field: "Preço (USD)",
    image_url: "URL da imagem",
    description: "Descrição",
    reply: "Responder",
    send_reply: "Enviar resposta",
    mark_read: "Marcar como lido",
    unread: "Não lido",
    from: "De",
    regarding: "Sobre",
    no_messages: "Ainda não há mensagens.",
    saved: "Salvo",
    deleted: "Excluído",
    reply_sent: "Resposta salva",
    confirm_delete: "Excluir este item?",
  },
  ru: {
    brand: "andywarhol.ai",
    tagline: "Маркетплейс печатной рекламы",
    hero_title: "Онлайн-рынок печатной рекламы",
    hero_sub: "Покупайте и продавайте оригинальную старинную печатную рекламу — камеры, телефоны, электронику и многое другое. Каждый экземпляр — подлинный фрагмент истории дизайна.",
    browse: "Просмотреть коллекцию",
    search_placeholder: "Поиск по бренду, теме или ключевому слову…",
    filters: "Фильтры",
    topic: "Тема",
    era: "Эпоха",
    ad_language: "Язык рекламы",
    all: "Все",
    sort: "Сортировка",
    sort_random: "Удивите меня",
    sort_newest: "Новейшие",
    sort_price_asc: "Цена: по возрастанию",
    sort_price_desc: "Цена: по убыванию",
    results: "экз.",
    clear: "Очистить всё",
    no_results: "Нет объявлений, соответствующих фильтрам.",
    inquire: "Запросить",
    view_details: "Подробнее",
    details: "Детали",
    condition: "Состояние",
    dimensions: "Размеры",
    brand_label: "Бренд",
    back: "Назад к коллекции",
    hover_zoom: "Наведите для увеличения",
    inquire_title: "Запрос об этом экземпляре",
    inquire_sub: "Отправьте нам сообщение, и мы свяжемся с вами по поводу покупки.",
    your_name: "Ваше имя",
    your_email: "Ваш e-mail",
    your_message: "Ваше сообщение",
    send: "Отправить запрос",
    sending: "Отправка…",
    inquiry_sent: "Ваш запрос отправлен. Спасибо!",
    inquiry_error: "Что-то пошло не так. Попробуйте ещё раз.",
    currency: "Валюта",
    language: "Язык",
    admin: "Админ",
    admin_login: "Вход администратора",
    email: "E-mail",
    password: "Пароль",
    login: "Войти",
    logout: "Выйти",
    dashboard: "Панель",
    manage_ads: "Объявления",
    messages: "Сообщения",
    add_ad: "Добавить объявление",
    edit: "Изменить",
    delete: "Удалить",
    save: "Сохранить",
    cancel: "Отмена",
    title_field: "Заголовок",
    price_field: "Цена (USD)",
    image_url: "URL изображения",
    description: "Описание",
    reply: "Ответить",
    send_reply: "Отправить ответ",
    mark_read: "Отметить прочитанным",
    unread: "Непрочитано",
    from: "От",
    regarding: "Касательно",
    no_messages: "Сообщений пока нет.",
    saved: "Сохранено",
    deleted: "Удалено",
    reply_sent: "Ответ сохранён",
    confirm_delete: "Удалить этот элемент?",
  },
  ja: {
    brand: "andywarhol.ai",
    tagline: "印刷広告のマーケットプレイス",
    hero_title: "印刷広告コレクションのオンラインマーケット",
    hero_sub: "オリジナルのヴィンテージ印刷広告を売買 — カメラ、電話、電子機器など。どれもデザイン史の本物の断片です。",
    browse: "コレクションを見る",
    search_placeholder: "ブランド・テーマ・キーワードで検索…",
    filters: "フィルター",
    topic: "テーマ",
    era: "年代",
    ad_language: "広告の言語",
    all: "すべて",
    sort: "並び替え",
    sort_random: "おまかせ",
    sort_newest: "新着",
    sort_price_asc: "価格: 安い順",
    sort_price_desc: "価格: 高い順",
    results: "点",
    clear: "すべてクリア",
    no_results: "条件に一致する広告はありません。",
    inquire: "問い合わせ",
    view_details: "詳細を見る",
    details: "詳細",
    condition: "状態",
    dimensions: "サイズ",
    brand_label: "ブランド",
    back: "コレクションに戻る",
    hover_zoom: "ホバーで拡大",
    inquire_title: "この作品について問い合わせる",
    inquire_sub: "メッセージをお送りください。購入についてご連絡します。",
    your_name: "お名前",
    your_email: "メールアドレス",
    your_message: "メッセージ",
    send: "問い合わせを送信",
    sending: "送信中…",
    inquiry_sent: "お問い合わせを送信しました。ありがとうございます！",
    inquiry_error: "問題が発生しました。もう一度お試しください。",
    currency: "通貨",
    language: "言語",
    admin: "管理者",
    admin_login: "管理者ログイン",
    email: "メール",
    password: "パスワード",
    login: "ログイン",
    logout: "ログアウト",
    dashboard: "ダッシュボード",
    manage_ads: "広告",
    messages: "メッセージ",
    add_ad: "広告を追加",
    edit: "編集",
    delete: "削除",
    save: "保存",
    cancel: "キャンセル",
    title_field: "タイトル",
    price_field: "価格 (USD)",
    image_url: "画像URL",
    description: "説明",
    reply: "返信",
    send_reply: "返信を送信",
    mark_read: "既読にする",
    unread: "未読",
    from: "差出人",
    regarding: "件名",
    no_messages: "まだメッセージはありません。",
    saved: "保存しました",
    deleted: "削除しました",
    reply_sent: "返信を保存しました",
    confirm_delete: "この項目を削除しますか？",
  },
  it: {
    brand: "andywarhol.ai",
    tagline: "Il mercato della pubblicità stampata",
    hero_title: "Il mercato online dei pezzi di pubblicità stampata",
    hero_sub: "Compra e vendi pubblicità stampate originali — fotocamere, telefoni, elettronica e altro. Ogni pezzo, un autentico frammento di storia del design.",
    browse: "Sfoglia la collezione",
    search_placeholder: "Cerca marca, tema o parola chiave…",
    filters: "Filtri",
    topic: "Tema",
    era: "Epoca",
    ad_language: "Lingua dell'inserzione",
    all: "Tutti",
    sort: "Ordina",
    sort_random: "Sorprendimi",
    sort_newest: "Più recenti",
    sort_price_asc: "Prezzo: crescente",
    sort_price_desc: "Prezzo: decrescente",
    results: "pezzi",
    clear: "Cancella tutto",
    no_results: "Nessuna inserzione corrisponde ai filtri.",
    inquire: "Richiedi info",
    view_details: "Vedi dettagli",
    details: "Dettagli",
    condition: "Condizione",
    dimensions: "Dimensioni",
    brand_label: "Marca",
    back: "Torna alla collezione",
    hover_zoom: "Passa il mouse per ingrandire",
    inquire_title: "Richiedi info su questo pezzo",
    inquire_sub: "Inviaci un messaggio e ti risponderemo per l'acquisto.",
    your_name: "Il tuo nome",
    your_email: "La tua email",
    your_message: "Il tuo messaggio",
    send: "Invia richiesta",
    sending: "Invio…",
    inquiry_sent: "La tua richiesta è stata inviata. Grazie!",
    inquiry_error: "Qualcosa è andato storto. Riprova.",
    currency: "Valuta",
    language: "Lingua",
    admin: "Admin",
    admin_login: "Accesso amministratore",
    email: "Email",
    password: "Password",
    login: "Accedi",
    logout: "Esci",
    dashboard: "Pannello",
    manage_ads: "Inserzioni",
    messages: "Messaggi",
    add_ad: "Aggiungi inserzione",
    edit: "Modifica",
    delete: "Elimina",
    save: "Salva",
    cancel: "Annulla",
    title_field: "Titolo",
    price_field: "Prezzo (USD)",
    image_url: "URL immagine",
    description: "Descrizione",
    reply: "Rispondi",
    send_reply: "Invia risposta",
    mark_read: "Segna come letto",
    unread: "Non letto",
    from: "Da",
    regarding: "Oggetto",
    no_messages: "Ancora nessun messaggio.",
    saved: "Salvato",
    deleted: "Eliminato",
    reply_sent: "Risposta salvata",
    confirm_delete: "Eliminare questo elemento?",
  },
  ko: {
    brand: "andywarhol.ai",
    tagline: "인쇄 광고 마켓플레이스",
    hero_title: "인쇄 광고 컬렉션 온라인 마켓",
    hero_sub: "오리지널 빈티지 인쇄 광고를 사고파세요 — 카메라, 휴대폰, 전자제품 등. 모든 작품은 디자인 역사의 진짜 조각입니다.",
    browse: "컬렉션 둘러보기",
    search_placeholder: "브랜드, 주제 또는 키워드 검색…",
    filters: "필터",
    topic: "주제",
    era: "시대",
    ad_language: "광고 언어",
    all: "전체",
    sort: "정렬",
    sort_random: "무작위 추천",
    sort_newest: "최신순",
    sort_price_asc: "가격: 낮은순",
    sort_price_desc: "가격: 높은순",
    results: "점",
    clear: "모두 지우기",
    no_results: "필터와 일치하는 광고가 없습니다.",
    inquire: "문의하기",
    view_details: "상세 보기",
    details: "상세정보",
    condition: "상태",
    dimensions: "크기",
    brand_label: "브랜드",
    back: "컬렉션으로 돌아가기",
    hover_zoom: "확대하려면 마우스를 올리세요",
    inquire_title: "이 작품에 대해 문의하기",
    inquire_sub: "메시지를 보내주시면 구매에 대해 연락드리겠습니다.",
    your_name: "이름",
    your_email: "이메일",
    your_message: "메시지",
    send: "문의 보내기",
    sending: "전송 중…",
    inquiry_sent: "문의가 전송되었습니다. 감사합니다!",
    inquiry_error: "문제가 발생했습니다. 다시 시도해 주세요.",
    currency: "통화",
    language: "언어",
    admin: "관리자",
    admin_login: "관리자 로그인",
    email: "이메일",
    password: "비밀번호",
    login: "로그인",
    logout: "로그아웃",
    dashboard: "대시보드",
    manage_ads: "광고",
    messages: "메시지",
    add_ad: "광고 추가",
    edit: "편집",
    delete: "삭제",
    save: "저장",
    cancel: "취소",
    title_field: "제목",
    price_field: "가격 (USD)",
    image_url: "이미지 URL",
    description: "설명",
    reply: "답장",
    send_reply: "답장 보내기",
    mark_read: "읽음 표시",
    unread: "안 읽음",
    from: "보낸사람",
    regarding: "관련",
    no_messages: "아직 메시지가 없습니다.",
    saved: "저장됨",
    deleted: "삭제됨",
    reply_sent: "답장 저장됨",
    confirm_delete: "이 항목을 삭제할까요?",
  },
  nl: {
    brand: "andywarhol.ai",
    tagline: "De marktplaats voor gedrukte advertenties",
    hero_title: "De onlinemarkt voor gedrukte advertentiestukken",
    hero_sub: "Koop en verkoop originele vintage drukadvertenties — camera's, telefoons, elektronica en meer. Elk stuk een echt fragment van designgeschiedenis.",
    browse: "Blader door de collectie",
    search_placeholder: "Zoek op merk, onderwerp of trefwoord…",
    filters: "Filters",
    topic: "Onderwerp",
    era: "Tijdperk",
    ad_language: "Advertentietaal",
    all: "Alle",
    sort: "Sorteren",
    sort_random: "Verras me",
    sort_newest: "Nieuwste",
    sort_price_asc: "Prijs: laag naar hoog",
    sort_price_desc: "Prijs: hoog naar laag",
    results: "stuks",
    clear: "Alles wissen",
    no_results: "Geen advertenties komen overeen met je filters.",
    inquire: "Informeren",
    view_details: "Details bekijken",
    details: "Details",
    condition: "Staat",
    dimensions: "Afmetingen",
    brand_label: "Merk",
    back: "Terug naar collectie",
    hover_zoom: "Beweeg om te zoomen",
    inquire_title: "Informeer naar dit stuk",
    inquire_sub: "Stuur ons een bericht en we nemen contact op over je aankoop.",
    your_name: "Je naam",
    your_email: "Je e-mail",
    your_message: "Je bericht",
    send: "Aanvraag verzenden",
    sending: "Verzenden…",
    inquiry_sent: "Je aanvraag is verzonden. Bedankt!",
    inquiry_error: "Er ging iets mis. Probeer opnieuw.",
    currency: "Valuta",
    language: "Taal",
    admin: "Beheer",
    admin_login: "Beheerderslogin",
    email: "E-mail",
    password: "Wachtwoord",
    login: "Inloggen",
    logout: "Uitloggen",
    dashboard: "Dashboard",
    manage_ads: "Advertenties",
    messages: "Berichten",
    add_ad: "Advertentie toevoegen",
    edit: "Bewerken",
    delete: "Verwijderen",
    save: "Opslaan",
    cancel: "Annuleren",
    title_field: "Titel",
    price_field: "Prijs (USD)",
    image_url: "Afbeeldings-URL",
    description: "Beschrijving",
    reply: "Beantwoorden",
    send_reply: "Antwoord verzenden",
    mark_read: "Markeer als gelezen",
    unread: "Ongelezen",
    from: "Van",
    regarding: "Betreft",
    no_messages: "Nog geen berichten.",
    saved: "Opgeslagen",
    deleted: "Verwijderd",
    reply_sent: "Antwoord opgeslagen",
    confirm_delete: "Dit item verwijderen?",
  },
  tr: {
    brand: "andywarhol.ai",
    tagline: "Basılı reklam pazarı",
    hero_title: "Basılı reklam parçalarının çevrimiçi pazarı",
    hero_sub: "Orijinal eski basılı reklamları alıp satın — kameralar, telefonlar, elektronik ve daha fazlası. Her parça tasarım tarihinin gerçek bir parçası.",
    browse: "Koleksiyona göz at",
    search_placeholder: "Marka, konu veya anahtar kelime ara…",
    filters: "Filtreler",
    topic: "Konu",
    era: "Dönem",
    ad_language: "Reklam dili",
    all: "Tümü",
    sort: "Sırala",
    sort_random: "Beni şaşırt",
    sort_newest: "En yeni",
    sort_price_asc: "Fiyat: artan",
    sort_price_desc: "Fiyat: azalan",
    results: "parça",
    clear: "Tümünü temizle",
    no_results: "Filtrelerinize uygun reklam yok.",
    inquire: "Bilgi al",
    view_details: "Detayları gör",
    details: "Detaylar",
    condition: "Durum",
    dimensions: "Boyutlar",
    brand_label: "Marka",
    back: "Koleksiyona dön",
    hover_zoom: "Yakınlaştırmak için üzerine gelin",
    inquire_title: "Bu parça hakkında bilgi al",
    inquire_sub: "Bize bir mesaj gönderin, satın alma konusunda size dönelim.",
    your_name: "Adınız",
    your_email: "E-postanız",
    your_message: "Mesajınız",
    send: "Talep gönder",
    sending: "Gönderiliyor…",
    inquiry_sent: "Talebiniz gönderildi. Teşekkürler!",
    inquiry_error: "Bir şeyler ters gitti. Lütfen tekrar deneyin.",
    currency: "Para birimi",
    language: "Dil",
    admin: "Yönetici",
    admin_login: "Yönetici girişi",
    email: "E-posta",
    password: "Parola",
    login: "Giriş yap",
    logout: "Çıkış yap",
    dashboard: "Panel",
    manage_ads: "Reklamlar",
    messages: "Mesajlar",
    add_ad: "Reklam ekle",
    edit: "Düzenle",
    delete: "Sil",
    save: "Kaydet",
    cancel: "İptal",
    title_field: "Başlık",
    price_field: "Fiyat (USD)",
    image_url: "Görsel URL",
    description: "Açıklama",
    reply: "Yanıtla",
    send_reply: "Yanıt gönder",
    mark_read: "Okundu işaretle",
    unread: "Okunmadı",
    from: "Gönderen",
    regarding: "Konu",
    no_messages: "Henüz mesaj yok.",
    saved: "Kaydedildi",
    deleted: "Silindi",
    reply_sent: "Yanıt kaydedildi",
    confirm_delete: "Bu öğe silinsin mi?",
  },
  pl: {
    brand: "andywarhol.ai",
    tagline: "Rynek reklamy drukowanej",
    hero_title: "Internetowy rynek drukowanych reklam",
    hero_sub: "Kupuj i sprzedawaj oryginalne dawne reklamy drukowane — aparaty, telefony, elektronikę i więcej. Każdy egzemplarz to prawdziwy fragment historii designu.",
    browse: "Przeglądaj kolekcję",
    search_placeholder: "Szukaj marki, tematu lub słowa kluczowego…",
    filters: "Filtry",
    topic: "Temat",
    era: "Epoka",
    ad_language: "Język reklamy",
    all: "Wszystkie",
    sort: "Sortuj",
    sort_random: "Zaskocz mnie",
    sort_newest: "Najnowsze",
    sort_price_asc: "Cena: rosnąco",
    sort_price_desc: "Cena: malejąco",
    results: "szt.",
    clear: "Wyczyść wszystko",
    no_results: "Żadna reklama nie pasuje do filtrów.",
    inquire: "Zapytaj",
    view_details: "Zobacz szczegóły",
    details: "Szczegóły",
    condition: "Stan",
    dimensions: "Wymiary",
    brand_label: "Marka",
    back: "Powrót do kolekcji",
    hover_zoom: "Najedź, aby powiększyć",
    inquire_title: "Zapytaj o ten egzemplarz",
    inquire_sub: "Wyślij nam wiadomość, a odezwiemy się w sprawie zakupu.",
    your_name: "Twoje imię",
    your_email: "Twój e-mail",
    your_message: "Twoja wiadomość",
    send: "Wyślij zapytanie",
    sending: "Wysyłanie…",
    inquiry_sent: "Twoje zapytanie zostało wysłane. Dziękujemy!",
    inquiry_error: "Coś poszło nie tak. Spróbuj ponownie.",
    currency: "Waluta",
    language: "Język",
    admin: "Admin",
    admin_login: "Logowanie administratora",
    email: "E-mail",
    password: "Hasło",
    login: "Zaloguj",
    logout: "Wyloguj",
    dashboard: "Panel",
    manage_ads: "Reklamy",
    messages: "Wiadomości",
    add_ad: "Dodaj reklamę",
    edit: "Edytuj",
    delete: "Usuń",
    save: "Zapisz",
    cancel: "Anuluj",
    title_field: "Tytuł",
    price_field: "Cena (USD)",
    image_url: "URL obrazu",
    description: "Opis",
    reply: "Odpowiedz",
    send_reply: "Wyślij odpowiedź",
    mark_read: "Oznacz jako przeczytane",
    unread: "Nieprzeczytane",
    from: "Od",
    regarding: "Dotyczy",
    no_messages: "Brak wiadomości.",
    saved: "Zapisano",
    deleted: "Usunięto",
    reply_sent: "Odpowiedź zapisana",
    confirm_delete: "Usunąć ten element?",
  },
};
